import KitchenZIndex from "../bvcomponents/kvComponent/core/zIndex";
import store from "../store";

export default function (canvasClass, containerX, layoutType, layoutScene) {
  // console.log('canvasClass', canvasClass);
  // console.log('layoutType', layoutType);
  // console.log('layoutScene', layoutScene);
  switch(document.kvConfig.visualizerType) {
    case "Bathroom":
    case "BV":
      switch (canvasClass) {
        case 'shower':
        case 'shower-shower':
        case 'shower-shower-body':
        case 'shower-interior-wall':
        case 'shower-shower-walls':
        case 'shower-fixture':
        case 'shower-shower_head':
        case 'shower-shower-head':
        case 'shower-floor':
        case 'shower-pan':
        case 'shower-tub-combo':
        case 'shower-shower-door':
        case 'shower-shower-door-handle':
        case 'shower-handle':
        case 'shower-shower-pan':
        case 'shower-interior-wall-accent':
        case 'shower-shower-walls-accent':
        case 'shower-tub-combo-wall-configuration':
        case 'shower-tub-combo-shower-door':
        case 'shower-tub-combo-handle':
        case 'shower-tub-combo-tub-liner':
        case 'shower-tub-combo-jetted-tub':
        case 'shower-tub-combo-replacement-tub':
        case 'shower-tub-combo-walk-in-tub':
        case 'shower-tub-combo-fixture':
        case 'shower-tub-combo-shower-head':
        case 'shower-tub-combo-shower_head':
        case 'shower-tub-combo-interior-wall':
        case 'shower-tub-combo-interior-wall-accent':
        case 'shower-tub-combo-shower-walls':
        case 'shower-tub-combo-shower-walls-accent':
        case 'shower-tub-combo-pony-wall-cap':
        case 'shower-tub-combo-pony-wall-glass':
        case 'shower-threshold':
        case 'shower-accessories':
        case 'shower-accessories-soap-dish':
        case 'shower-accessories-large-corner-seat':
        case 'shower-accessories-corner-caddie':
        case 'shower-accessories-large-corner-caddie':
        case 'shower-accessories-small-corner-shelf':
        case 'shower-accessories-grab-bar':
          return containerX < 680 ? '-38%' : '-33%';
        case 'shower-pony-wall':
        case 'shower-pony-wall-cap':
        case 'shower-pony-wall-glass':
        case 'pony-wall':
        case 'wall-pony-wall':
          if (layoutType === "Small") { // small room layout
            return containerX < 680 ? '-60%' : '-50%';
          } else { // large room layout
            return containerX < 680 ? '-38%' : '-33%';
          }
        case 'window':
        case 'wall-c':
        case 'wall-wall-c':
          return containerX < 680 ? '-60%' : '-50%';
        case 'bathtub':
        case 'bathtub-bathtub':
        case 'bathtub-fixture':
        case 'bathtub-base':
        case 'bathtub-rim':
        case 'bathtub-spa':
          if (window.innerWidth < 991) {
            window.scrollTo({
              top: window.innerHeight,
              behavior: "smooth"
            });
          }
          return containerX < 680 ? '-60%' : '-50%';
        case 'toilet':
        case 'toilet-toilet':
          return containerX < 680 ? '-18%' : '-14.5%';
        case 'left-shower-wall':
        case 'wall-left-shower-wall':
          if (layoutType === "Small") { // small room layout
            return containerX < 680 ? '-50%' : '-45%';
          } else { // large room layout
            return containerX < 680 ? '-22%' : '-18%';
          }
        case 'right-shower-wall':
        case 'wall-right-shower-wall':
          if (layoutType === "Small") { // small room layout
            return containerX < 680 ? '-22%' : '-18%';
          } else { // large room layout
            return containerX < 680 ? '-50%' : '-45%';
          }
        case 'floor':
          return containerX < 680 ? '-40%' : '-35%';
        default:
          return "0"
      }
    case "bvScene":
    case "bvLook": {
      switch (canvasClass) {
        case 'shower':
        case 'shower-head':
        case 'shower-shower':
        case 'shower-shower-body':
        case 'shower-interior-wall':
        case 'shower-shower-walls':
        case 'shower-fixture':
        case 'shower-shower_head':
        case 'shower-shower-head':
        case 'shower-floor':
        case 'shower-pan':
        case 'shower-tub-combo':
        case 'shower-shower-door':
        case 'shower-shower-door-handle':
        case 'shower-handle':
        case 'shower-shower-pan':
        case 'shower-interior-wall-accent':
        case 'shower-shower-walls-accent':
        case 'shower-tub-combo-wall-configuration':
        case 'shower-tub-combo-shower-door':
        case 'shower-tub-combo-handle':
        case 'shower-tub-combo-tub-liner':
        case 'shower-tub-combo-jetted-tub':
        case 'shower-tub-combo-replacement-tub':
        case 'shower-tub-combo-walk-in-tub':
        case 'shower-tub-combo-fixture':
        case 'shower-tub-combo-shower-head':
        case 'shower-tub-combo-shower_head':
        case 'shower-tub-combo-interior-wall':
        case 'shower-tub-combo-interior-wall-accent':
        case 'shower-tub-combo-shower-walls':
        case 'shower-tub-combo-shower-walls-accent':
        case 'shower-tub-combo-pony-wall-cap':
        case 'shower-tub-combo-pony-wall-glass':
        case 'shower-threshold':
        case 'shower-accessories':
        case 'shower-accessories-soap-dish':
        case 'shower-accessories-large-corner-seat':
        case 'shower-accessories-corner-caddie':
        case 'shower-accessories-large-corner-caddie':
        case 'shower-accessories-small-corner-shelf':
        case 'shower-accessories-grab-bar':
        case 'shower-pony-wall':
        case 'shower-pony-wall-cap':
        case 'shower-pony-wall-glass':
        case 'pony-wall':
        case 'wall-pony-wall':
          if (layoutType === "Layout4") { // small room layout
            return containerX < 680 ? '-40%' : '-23%';
          } else { // large room layout
            return "0";
          }
        case 'window':
        case 'wall-c':
        case 'wall-wall-c':
        case 'right-wall':
          return containerX < 680 ? '-60%' : '-50%';
        case 'bathtub':
        case 'bathtub-bathtub':
        case 'bathtub-fixture':
        case 'bathtub-base':
        case 'bathtub-rim':
        case 'bathtub-spa':
          if (window.innerWidth < 991) {
            window.scrollTo({
              top: window.innerHeight,
              behavior: "smooth"
            });
          }
          return containerX < 680 ? '-60%' : '-50%';
        case 'toilet':
        case 'toilet-toilet': {
          switch (layoutType) {
            case "Layout1":
              return containerX < 680 ? '-18%' : '-14.5%';
            default:
              break;
          }
          break;
        }
        case 'left-shower-wall':
        case 'wall-left-shower-wall':
          if (layoutType === "Small") { // small room layout
            return containerX < 680 ? '-50%' : '-45%';
          } else { // large room layout
            return containerX < 680 ? '-22%' : '-18%';
          }
        case 'right-shower-wall':
        case 'wall-right-shower-wall':
          if (layoutType === "Small") { // small room layout
            return containerX < 680 ? '-22%' : '-18%';
          } else { // large room layout
            return containerX < 680 ? '-50%' : '-45%';
          }
        case 'floor':
          return containerX < 680 ? '-22%' : '-18%';
        default:
          return "0"
      }
      return "0"
    }
    case "Kitchen":
    case "KV":
      switch (canvasClass) {
        //APPLIANCE
        case 'hood':
        case 'microwave':
        case 'range':
        case 'appliance-hood':
        case 'appliance-range':
        case 'appliance-microwave':
          return containerX < 680 ? '-39%' : '-37%';
        case 'dishwasher':
        case 'appliance-dishwasher':
          return containerX < 680 ? '-23%' : '-20%';
        case 'fridge':
        case 'appliance-fridge':
          switch (layoutType) {
            case "Small":
            case "SmallWithPeninsula":
            case "SmallWithIsland":
            case "SmallWithPeninsulaWithIsland":
              return containerX < 680 ? '-15%' : '-13%';
            default:
              return "0";
          }
          //CABINET
        case "cabinet":
        case "top-cabinet":
        case "cabinet-top-cabinet":
        case "handle":
        case "cabinet-top-handle":
        case "cabinet-bottom-handle":
        case "crown-molding":
        case "cabinet-crown-molding":
        case 'bottom-cabinet':
        case 'cabinet-bottom-cabinet': {
          if (document.hoveredLayer
            && (document.hoveredLayer.zIndex === KitchenZIndex.layouts[layoutType].Cabinet.Peninsula)
            && window.innerWidth < 991) {
            window.scrollTo({
              top: window.innerHeight,
              behavior: "smooth"
            });
          }
          const module = store.getState().navigationState.moduleContextMenuModule;
          // console.log('module', module);
          switch (module) {
            case "1":
            case "2":
            case "3":
              return "0";
            case "4":
              return containerX < 680 ? '-19%' : '-17%';
            case "5":
              return containerX < 680 ? '-27%' : '-25%';
            case "6":
              return containerX < 680 ? '-43%' : '-40%';
            case null:
            default:
              return containerX < 680 ? '-60%' : '-50%';
          }
        }
          //CENTER ISLAND
        case 'center-island':
        case 'center-island-countertop':
        case 'center-island-edge':
        case 'center-island-cabinet':
        case 'center-island-sink':
        case 'center-island-faucet':
          return containerX < 680 ? '-22%' : '-18%';
        case 'chairs':
        case 'center-island-chairs':
          return containerX < 680 ? '-5%' : '-4%';
        case 'center-island-handle':
          return containerX < 680 ? '-27%' : '-25%';
          //COUNTERTOP
        case 'countertop-countertop':
        case 'countertop-edge-profile':
        case 'countertop-sink':
        case 'countertop-faucet':
          return containerX < 680 ? '-60%' : '-50%';
        case 'countertop':
          if (document.hoveredLayer) {
            switch (document.hoveredLayer.zIndex) {
              case KitchenZIndex.layouts[layoutType].CenterIsland.Countertop:
                return containerX < 680 ? '-22%' : '-18%';
              case KitchenZIndex.layouts[layoutType].CountertopGroup.Countertop2:
                return containerX < 680 ? '-60%' : '-50%';
              case KitchenZIndex.layouts[layoutType].CountertopGroup.Countertop:
                return containerX < 680 ? '-15%' : '-13%';
              default:
                return "0"
            }
          }
          return "0";
        case 'faucet':
          if (document.hoveredLayer && document.hoveredLayer.zIndex === KitchenZIndex.layouts[layoutType].CenterIsland.Faucet) {
            return containerX < 680 ? '-22%' : '-18%';
          } else {
            return containerX < 680 ? '-60%' : '-50%';
          }
        case 'sink':
          if (document.hoveredLayer && document.hoveredLayer.zIndex === KitchenZIndex.layouts[layoutType].CenterIsland.Sink) {
            return containerX < 680 ? '-22%' : '-18%';
          } else {
            return containerX < 680 ? '-60%' : '-50%';
          }
          //WALLS
        case "backsplash":
        case "walls-backsplash":
        case "ceiling":
        case "walls-ceiling":
          return containerX < 680 ? '-15%' : '-13%';
        case "right-wall":
        case "walls-right-wall":
          return containerX < 680 ? '-37%' : '-35%';
        default:
          return "0"
      }
    case "kvScene":
      switch(layoutType) {
        case "Layout1": {
          switch (layoutScene) {
            case "1": {
              switch (canvasClass) {
                //CENTER ISLAND
                case 'center-island':
                case 'center-island-countertop':
                case 'center-island-island-countertop':
                case 'center-island-stovetop':
                case 'center-island-edge':
                case 'center-island-cabinet':
                case 'center-island-sink':
                case 'center-island-faucet':
                case 'centerisland':
                case 'centerisland-countertop':
                case 'centerisland-island-countertop':
                case 'centerisland-stovetop':
                case 'centerisland-edge':
                case 'centerisland-cabinet':
                case 'centerisland-sink':
                case 'centerisland-faucet':
                  return containerX < 680 ? '-30%' : '-23%';
                case 'chairs':
                case 'centerisland-chairs':
                case 'centerisland-handle':
                case 'centerisland-island-hood':
                  return containerX < 680 ? '-35%' : '-30%';
                case 'faucet':
                case 'countertop-faucet':
                case 'sink':
                case 'countertop-sink':
                  return containerX < 680 ? '-15%' : '-10%';
                case 'walls-right-wall':
                  return containerX < 680 ? '-40%' : '-32%';
                case 'walls-center-wall':
                  return containerX < 680 ? '-48%' : '-44%';
                case 'walls-front-wall':
                  return '-50%';
                default:
                  return "0"
              }
            }
            case "2": {
              switch (canvasClass) {
                //CENTER ISLAND
                case 'center-island':
                case 'center-island-countertop':
                case 'center-island-island-countertop':
                case 'center-island-stovetop':
                case 'center-island-edge':
                case 'center-island-cabinet':
                case 'center-island-sink':
                case 'center-island-faucet':
                case 'centerisland':
                case 'centerisland-countertop':
                case 'centerisland-island-countertop':
                case 'centerisland-stovetop':
                case 'centerisland-edge':
                case 'centerisland-cabinet':
                case 'centerisland-sink':
                case 'centerisland-faucet':
                  return containerX < 680 ? '-30%' : '-23%';
                case 'chairs':
                case 'centerisland-chairs':
                case 'centerisland-handle':
                case 'centerisland-island-hood':
                  return containerX < 680 ? '-35%' : '-30%';
                case 'faucet':
                case 'countertop-faucet':
                case 'sink':
                case 'countertop-sink':
                  return containerX < 680 ? '-15%' : '-10%';
                case 'walls-center-wall':
                  return containerX < 680 ? '-48%' : '-44%';
                case 'walls-front-wall':
                case 'walls-right-wall':
                  return '-50%';
                default:
                  return "0"
              }
            }
            case "3": {
              switch (canvasClass) {
                //CENTER ISLAND
                case 'center-island':
                case 'center-island-countertop':
                case 'center-island-island-countertop':
                case 'center-island-stovetop':
                case 'center-island-edge':
                case 'center-island-cabinet':
                case 'center-island-sink':
                case 'center-island-faucet':
                case 'centerisland':
                case 'centerisland-countertop':
                case 'centerisland-island-countertop':
                case 'centerisland-stovetop':
                case 'centerisland-edge':
                case 'centerisland-cabinet':
                case 'centerisland-sink':
                case 'centerisland-faucet':
                case 'appliances-hood':
                case 'appliances-stove':
                case 'appliances-stovetop':
                case 'walls-backsplash':
                  return containerX < 680 ? '-30%' : '-23%';
                case 'appliances-dishwasher':
                  return containerX < 680 ? '-35%' : '-30%';
                case 'faucet':
                case 'countertop-faucet':
                case 'sink':
                case 'countertop-sink':
                case 'walls-right-wall':
                case 'countertop-edge-profile':
                case 'countertop-countertop':
                  return '-50%';
                default:
                  return "0"
              }
            }
            default:
              return "0"
          }
        }
        case "Layout2": {
          switch (canvasClass) {
            //CENTER ISLAND
            case 'faucet':
            case 'countertop-faucet':
            case 'sink':
            case 'countertop-sink':
            case 'countertop-edge-profile':
            case 'walls-front-wall':
            case 'countertop-countertop':
            case 'walls-backsplash':
              return containerX < 680 ? '-25%' : '-20%';
            case 'appliances-hood':
            case 'appliances-stove':
            case 'appliances-oven':
              return containerX < 680 ? '-45%' : '-37%';
            case 'walls-center-wall':
              return containerX < 680 ? '-48%' : '-44%';
            case 'walls-right-wall':
            case 'appliances-fridge':
            case 'appliances-fridge-enclosure':
              return '-50%';
            default:
              return "0"
          }
        }
        case "Layout3": {
          switch (canvasClass) {
            //CENTER ISLAND
            case 'faucet':
            case 'countertop-faucet':
            case 'sink':
            case 'countertop-sink':
            case 'countertop-edge-profile':
            case 'walls-front-wall':
            case 'countertop-countertop':
            case 'walls-backsplash':
              return containerX < 680 ? '-25%' : '-20%';
            case 'appliances-hood':
            case 'appliances-stove':
            case 'appliances-oven':
              return containerX < 680 ? '-18%' : '-15%';
            case 'center-island':
            case 'center-island-countertop':
            case 'center-island-island-countertop':
            case 'center-island-stovetop':
            case 'center-island-edge':
            case 'center-island-cabinet':
            case 'center-island-sink':
            case 'center-island-faucet':
            case 'centerisland':
            case 'centerisland-countertop':
            case 'centerisland-island-countertop':
            case 'centerisland-stovetop':
            case 'centerisland-edge':
            case 'centerisland-cabinet':
            case 'centerisland-sink':
            case 'centerisland-faucet':
              return '-50%';
            default:
              return "0"
          }
        }
        default:
          return "0"
      }
    default:
      return "0"
  }
}
